import { Group } from '@mantine/core';
import { useCallback } from 'react';
import IconButton from '@ui/components/IconButton/IconButton';
import EmailChipsInput from '@ui/components/EmailChipsInput/EmailChipsInput';
import ProjectMemberRoleSelector, { RoleOption } from '@projectMembers/components/ProjectMembersList/ProjectMemberRoleSelector/ProjectMemberRoleSelector';
import ProjectRole, { ProjectMemberRoleType } from '@projectMembers/models/projectRole';
import Tooltip from 'src/components/UI/Tooltip/Tooltip';
import OverviewPermissionTooltip from 'src/new_arch/modules/projectView/components/OverviewPermissionTooltip/OverviewPermissionTooltip';
import { UPGRADE_REQUEST_SOURCES } from 'src/new_arch/modules/projectView/components/OverviewPermissionTooltip/upgradeRequestSources';

import styles from './EmailsInput.module.scss';

type EmailsInputProps = {
	emails: string[];
	role: ProjectRole;
	roleOptions: RoleOption[];
	emailValidator: ( email: string ) => boolean;
	onEmailsChange: ( emails: string[] ) => void;
	onRoleChange: ( role: ProjectRole ) => void;
	onAddGroupClick?: () => void;
	canManageContactGroups?: boolean;
	projectID?: number;
};

const EmailsInput = ( {
	emails, role, roleOptions, emailValidator, onEmailsChange, onRoleChange, onAddGroupClick,
	canManageContactGroups = true, projectID
}: EmailsInputProps ) => {
	const onRoleChanged = useCallback( ( roleType: ProjectMemberRoleType ) => {
		const newRole = ProjectRole.fromID( roleType );
		if ( newRole ) onRoleChange( newRole );
	}, [ onRoleChange ] );

	return (
		<Group
			className={styles.EmailsInputWrapper}
			position="apart"
			noWrap
			spacing={12}
			align="flex-start"
		>
			<EmailChipsInput
				emails={emails}
				onEmailsChange={onEmailsChange}
				emailValidator={emailValidator}
			/>
			<Group h={30} align="center" spacing={8}>
				<ProjectMemberRoleSelector
					selectedRole={role}
					roleOptions={roleOptions}
					showDelete={false}
					onChange={onRoleChanged}
				/>
				{canManageContactGroups ? (
					<Tooltip title="Add group">
						<IconButton
							icon="perm-contact-calendar-outlined"
							size={18}
							variant="transparent"
							color="dark.3"
							onClick={onAddGroupClick}
						/>
					</Tooltip>
				) : (
					<OverviewPermissionTooltip
						projectID={projectID!}
						source={UPGRADE_REQUEST_SOURCES.COLLABORATOR_GROUPS}
						description={null}
					>
						<IconButton
							icon="perm-contact-calendar-outlined"
							size={18}
							variant="transparent"
							color="dark.3"
						/>
					</OverviewPermissionTooltip>
				)}
			</Group>
		</Group>
	);
};

export default EmailsInput;
